import ApiConstants from "../../Constants/ApiConstant";
import { apiGet, apiPost } from "../../Services/ApiService";

export const getWalletTransactionAPI = (
  transactionAmount,
  params,
  callBack
) => {
  return async () => {
    // let url = `${ApiConstants.walletTransactionUrl}?transaction_amount=${transactionAmount}`;
    let url = ApiConstants.walletTransactionUrl;
    const queryParams = [];

    if (params.startDate) {
      queryParams.push(`start_date=${encodeURIComponent(params.startDate)}`);
    }
    if (params.endDate) {
      queryParams.push(`end_date=${encodeURIComponent(params.endDate)}`);
    }
    // if (params.transactionTypeId) {
    //   queryParams.push(`transaction_type_id=${encodeURIComponent(params.transactionTypeId)}`);
    // }
    // ✅ Handle multiple transaction type IDs (Order grouping support)
    if (
      Array.isArray(params.transactionTypeIds) &&
      params.transactionTypeIds.length > 0
    ) {
      queryParams.push(
        `transaction_type_id=${params.transactionTypeIds.join(",")}`
      );
    }

    if (params.transactionStatusId) {
      queryParams.push(`transaction_status_id=${encodeURIComponent(params.transactionStatusId)}`);
    }
    // Append query parameters to URL if they exist
    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }
    try {
      await apiGet(url)
        .then((response) => {
          callBack && callBack(response, response);
        })
        .catch((err) => {
          throw err;
        });
    } catch (err) {
      throw err;
    }
  };
};

export const addTransactionAPI = (data, callback) => {
  return async () => {
    try {
      await apiPost(ApiConstants.addWalletTransactionUrl, data)
        .then((response) => {
          callback && callback(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("add transaction api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("add transaction api err:", err);
      throw err;
    }
  };
};
export const createWalletAPI = (data, callback) => {
  return async () => {
    try {
      await apiPost(ApiConstants.createWalletUrl, data)
        .then((response) => {
          callback && callback(response?.data, response?.data);
        })
        .catch((err) => {
          console.error("add transaction api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.error("add transaction api err:", err);
      throw err;
    }
  };
};
export const applyWalletCheckAPI = (data, callback) => {
  return async () => {
    try {
      await apiPost(ApiConstants.applyWalletCheckUrl, data)
        .then((response) => {
          callback && callback(response?.data, response?.data);
        })
        .catch((err) => {
          console.error("apply wallet check api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.error("apply wallet check api err:", err);
      throw err;
    }
  };
};

export const latestWalletTransactionUrl = (data, callback) => {
  return async () => {
    try {
      await apiGet(ApiConstants.latestWalletTransactionUrl)
        .then((response) => {
          callback && callback(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("latest wallet transaction api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("latest wallet transaction api err:", err);
      throw err;
    }
  };
};

